import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 10,
	viewBox: "0 0 6 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.39949 4.66667L0.223919 1.40209C0.0746395 1.24863 0 1.05331 0 0.816143C0 0.578974 0.0746395 0.383657 0.223919 0.230194C0.373198 0.0767314 0.563189 0 0.793893 0C1.0246 0 1.21459 0.0767314 1.36387 0.230194L5.10941 4.08072C5.19084 4.16442 5.24852 4.25511 5.28244 4.35277C5.31637 4.45042 5.33333 4.55506 5.33333 4.66667C5.33333 4.77828 5.31637 4.88291 5.28244 4.98057C5.24852 5.07823 5.19084 5.16891 5.10941 5.25262L1.36387 9.10314C1.21459 9.2566 1.0246 9.33333 0.793893 9.33333C0.563189 9.33333 0.373198 9.2566 0.223919 9.10314C0.0746395 8.94968 0 8.75436 0 8.51719C0 8.28002 0.0746395 8.0847 0.223919 7.93124L3.39949 4.66667Z",
		fill: "currentColor"
	})
});
export default SvgChevron;
